import { Flex, Input, Select, Tag, TagLabel, Text, Textarea } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import useRiskScore from "../../../../hooks/useRiskScore";

const OnboardingStep51 = ({ formData, handleChange }) => {
  
  const { overallScore, getScoreColor } = useRiskScore();

  return (
   <>

<Flex direction="column" gap={8}>
        <h6>Due diligence status</h6>
        <Flex direction="column">
        <Fieldset
            label="Risk conclusion"
            description="Average risk rating"
            input={
              <Tag
                size="lg"
                variant="solid"
                colorScheme={getScoreColor(overallScore)}
              >
                <TagLabel>{overallScore}</TagLabel>
              </Tag>
            }
          />

        </Flex>
      </Flex>


      <Flex direction="column" gap={8}>
        <h6>CAC decision</h6>
        <Flex direction="column">
        <Fieldset
            label="Status"
            description="Select the status of the CAC decision"
            input={
              <Select
                name="cacStatus"
                placeholder="Select status"
                value={formData.cacStatus}
                onChange={handleChange}
              >
                <option value="Pending">Under review</option>
                <option value="Approved">Approved</option>
                <option value="ApprovedUnderCondition">Approved under conditions</option>
                <option value="Rejected">Rejected</option>
              </Select>
            }
          />
          <Fieldset
            label="Committee decision date"
            description="Select the date of the CAC decision"
            input={
              <Input
                name="cacDecisionDate"
                type="date"
                value={formData.cacDecisionDate}
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Members present"
            description="Select the members present at the CAC decision"
            input={
              <Text color="red">to review</Text>
            }
          />

          <Fieldset
            label="Conditions set"
            description="Describe the conditions set at the CAC decision"
            input={
              <Textarea />
            }
          />

          <Fieldset
            label="Follow up actions"
            description="Describe the follow up actions set at the CAC decision"
            input={
              <Textarea />
            }
          />

        </Flex>
      </Flex>



   </>
  );
};

export default OnboardingStep51;
